import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";

export default function Catalog() {
  const [books, setBooks] = useState([]);
  useEffect(() => {
    api.get("/books").then((r) => setBooks(r.data.books || []));
  }, []);

  return (
    <div className="max-w-[1360px] mx-auto px-6 lg:px-12 pt-16 pb-24">
      <div className="grid lg:grid-cols-12 gap-10 items-end mb-16">
        <div className="lg:col-span-8">
          <p className="eyebrow">The Catalog</p>
          <h1 className="font-serif-display text-5xl sm:text-6xl lg:text-7xl leading-none tracking-tighter mt-6" data-testid="catalog-title">
            Every book we've<br/><em className="italic text-[#B85C38]">quietly</em> published.
          </h1>
        </div>
        <div className="lg:col-span-4">
          <p className="text-[#5C5C5C] leading-relaxed">
            A small, growing shelf. We add rarely and remove nothing. All titles ship as high-quality PDFs to your library and email.
          </p>
        </div>
      </div>

      <div className="hairline mb-16" />

      <div className={`grid gap-x-10 gap-y-16 ${books.length === 1 ? "md:grid-cols-1" : "md:grid-cols-2 lg:grid-cols-3"}`}>
        {books.map((b, i) => (
          <div key={b.id} data-testid={`book-card-${b.slug}`} className={books.length === 1 ? "grid md:grid-cols-12 gap-10 items-center" : ""}>
            <Link to={`/book/${b.slug}`} className={`group block ${books.length === 1 ? "md:col-span-5" : ""}`}>
              <div className="aspect-[3/4] overflow-hidden bg-[#E5E2DC]">
                <img src={b.cover_image} alt={b.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.03]" />
              </div>
            </Link>
            <div className={books.length === 1 ? "md:col-span-7" : "mt-5"}>
              <div className="flex items-baseline justify-between">
                <p className="eyebrow">Vol. {String(i + 1).padStart(2, "0")}</p>
                <p className="font-serif-display text-xl">${b.price?.toFixed(2)}</p>
              </div>
              <Link to={`/book/${b.slug}`} className="block group">
                <h2 className="font-serif-display text-3xl mt-2 leading-tight group-hover:text-[#B85C38] transition-colors">{b.title}</h2>
              </Link>
              <p className="italic font-serif-display text-[#5C5C5C] mt-1">{b.subtitle}</p>
              <p className="text-sm text-[#1C1C1C] mt-4 leading-relaxed">{b.short_description}</p>
              <div className="mt-6 flex flex-wrap gap-3">
                <Link to={`/checkout/${b.id}`} data-testid={`catalog-buy-${b.slug}`} className="btn-primary">
                  Get your copy · ${b.price?.toFixed(2)}
                </Link>
                <Link to={`/book/${b.slug}`} data-testid={`catalog-read-${b.slug}`} className="btn-ghost">
                  Read the sample
                </Link>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
